// extracted by mini-css-extract-plugin
module.exports = {"root":"d2qHvAva3ArjmoRS9eE8","wide":"Zn5srQT99e73s_C9PGhH"};